import Headers from "../../../config/paymentConfig/headers";
import ApiCalls from "../../../config/paymentConfig/apiCalls";
import { IS_INDIA } from "../../../helpers/paymentHelpers/paymentConstants";
import Utility from "../../../helpers/paymentHelpers/utility";
import LocalStorageFunc from "../../../helpers/paymentHelpers/localStorageFunc";
// import { EndPoints } from "../../../config/paymentConfig/apiEndpoints";
import get from "lodash/get";
// import ampUtility from "../../../helpers/paymentHelpers/amplitude/ampUtility";

export default {
  namespaced: true,
  state: {
    appConfig: {},
    pwaConfig: {},
    displayNetPrice: LocalStorageFunc.getDisplayNetPrice() || 0,
  },
  getters: {},
  mutations: {
    updateAppConfig(state, payload) {
      state.appConfig = {
        timeLastStored: new Date().getTime(),
        config: payload,
      };
    },
    updatePwaConfig(state, payload) {
      state.pwaConfig = payload;
    },
    updateDisplayPrice(state, payload) {
      state.displayNetPrice = payload;
      LocalStorageFunc.setDisplayNetPrice(payload);
    },
  },
  actions: {
    getPWAConfig({ commit, state, dispatch }, payload) {
      try {
        const vendor = Utility.getMiniAppStorageVal();
        const clientId = "merchant-dominos-pizza-uat";

        ApiCalls.GET_PWA_CONFIG({
          headers: Headers(),
          payload: {},
        })
          .then((res) => {
            if (res?.data) {
              let response = res.data;
              if (response.disableCookies) {
                LocalStorageFunc.setLocalStorageValue("disableCookies", true);
              }

              // START : Hardcoding config values for PAYTM here to solve issue ( login not happening for new users 1st time entering the miniapp - its happening 2nd time onwards in their journey)
              if (vendor === "PAYTM") {
                response.vendorConfig = {
                  PAYTM: {
                    partnerName: "paytm",
                    primaryPaymentId: "PAYTMMP_CC",
                    clientId,
                    source: "Paytm-microapp",
                  },
                  blockedFeatures: [
                    "irctc",
                    "feedback",
                    "deals_and_offer",
                    "deliver_on_train",
                    "wallet",
                    "support",
                    "logout",
                    "offers",
                    "showAppBanner",
                    "everyday_value_offer",
                    "edv",
                  ],
                };
              }
              // END : Hardcoding config values for PAYTM here to solve issue

              if (response.vendorConfig && vendor !== "PAYTM") {
                response.vendorConfig = Utility.jsonParser(
                  response.vendorConfig
                );
                // response.vendorConfig[vendor].clientId = clientId; // this will happen in case of PAYTM only
              }

              if (vendor) {
                const featuresData = JSON.parse(
                  get(response, `features`, "{}")
                );
                const vendorBlockedFeatures = get(
                  response,
                  `vendorConfig.blockedFeatures`,
                  []
                );
                for (let idx = 0; idx < featuresData.features.length; idx++) {
                  if (
                    vendorBlockedFeatures.indexOf(
                      featuresData.features[idx]
                    ) !== -1
                  ) {
                    featuresData.features.splice(idx, 1);
                  }
                }
                response.features = JSON.stringify(featuresData);
              }

              commit("updatePwaConfig", response);
            }
          })
          .catch((error) => {
            console.log("Get PWA config Error...", error);
          });
      } catch (err) {
        console.error("ERROR: getConfigSaga", err.message);
      }
    },
    getAppConfig({ commit, state, dispatch }, payload) {
      try {
        ApiCalls.GET_APP_CONFIG({
          headers: Headers(),
          payload: {},
        })
          .then((res) => {
            if (res?.data) {
              let response = res.data;
              commit("updateAppConfig", response);
              const isMiniApp = ["true", true].includes(
                Utility.checkIfIsMiniApp()
              );
              localStorage.isDefaultWalletApplied =
                IS_INDIA && response.isDefaultWalletApplied;
              // const storageIsWalletUsed = [
              // 	'undefined',
              // 	'null',
              // 	undefined,
              // 	null,
              // 	'true',
              // 	true
              // ].includes(localStorage.isWalletUsed);

              // const isWalletUsed =
              // 	IS_INDIA && storageIsWalletUsed
              // 		? isMiniApp
              // 			? false
              // 			: response.isDefaultWalletApplied
              // 		: storageIsWalletUsed;
              // LocalStorageFunc.setLocalStorageValue('isWalletUsed', isWalletUsed);
            }
          })
          .catch((error) => {
            console.log("Get APP config Error...", error);
          });
      } catch (error) {
        console.error("ERROR in getAppConfigSaga", error);
      }
    },
    amplitudePaymentStatus({ commit, rootState, state, dispatch }, payload) {
      const paymentModeTemp = get(
        rootState,
        "PaymentSubmit.paymentModeTemp",
        {}
      );
      const {
        cardScheme = "",
        issuerDisplayName = "",
        paymentId = "",
        label = "",
        paymentMode = "",
      } = paymentModeTemp;
      // ampUtility.paymentStatusEventAmp({
      // 	eventAction: payload.action,
      // 	eventLabel: label,
      // 	paymentMode: paymentMode,
      // 	paymentId: paymentId,
      // 	bankName: issuerDisplayName,
      // 	cardType: cardScheme,
      // 	errormsg: payload.errorText || "",
      // 	paymentGateway: payload.pg || "",
      // 	paymentAction: payload.pAction || "",
      // 	Page_Name: "payment_lp",
      // 	previousScreenname: "cart"
      // });
    },
  },
};
